import { render, staticRenderFns } from "./productFilter.vue?vue&type=template&id=bd59c996"
import script from "./productFilter.vue?vue&type=script&lang=js"
export * from "./productFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports